import React from 'react'
import './portfolio.css'
// ADD IMAGES FROM PORTFOLIO PROJECTS TO CREATE
import IMG1 from '../../assests/SVM.png'
import IMG2 from '../../assests/travelling-salesman.png'
import IMG3 from '../../assests/ps8-2-c-1.jpg'
import IMG4 from '../../assests/ps7-2-c.png'
import IMG5 from '../../assests/Screen Shot 2022-10-25 at 6.02.01 PM.png'
import IMG6 from '../../assests/image.png'
import IMG7 from '../../assests/Image 2.png'
const Portfolio = () => {
  return (
    <section id='portfolio'>
      <h5>My Recent Work</h5>
      <h2>Portfolio</h2>

      <div className="container portfolio__container">
      <article className="portfolio__item">
          <div className="portfolio__item-image">
            <img src={IMG7} alt="" />
          </div>
          <h3>AI Powered Fitness Trainer</h3>
          <div className="portfolio__item-cta">
            <a href='https://github.com/jimmyschi/AI-Powered-Fitness-Trainer/blob/main/README.md' className='btn' target='_blank'>Video Demonstration</a>
            {/* <a href='https://github.com/jimmyschi' className='btn primary' target='_blank'>Live Demo</a> */}
          </div>
        </article>
        <article className="portfolio__item">
          <div className="portfolio__item-image">
            <img src={IMG1} alt="" />
          </div>
          <h3>Senior Design Project: Doppler Shift Radar Gun Pitch Classification</h3>
          <div className="portfolio__item-cta">
            <a href='https://github.com/jimmyschi/MLB-Classification/blob/main/README.md' className='btn' target='_blank'>Github</a>
            {/* <a href='https://github.com/jimmyschi' className='btn primary' target='_blank'>Live Demo</a> */}
          </div>
        </article>
        <article className="portfolio__item">
          <div className="portfolio__item-image">
            <img src={IMG3} alt="" />
          </div>
          <h3>K-Means Clustering for Image Segmentation</h3>
          <div className="portfolio__item-cta">
            <a href='https://github.com/jimmyschi/Machine-Learning/blob/main/ps8_python_Schiavo_James/ps8.py' className='btn' target='_blank'>Github</a>
            {/* <a href='https://github.com/jimmyschi' className='btn primary' target='_blank'>Live Demo</a> */}
          </div>
        </article>
        <article className="portfolio__item">
          <div className="portfolio__item-image">
            <img src={IMG4} alt="" />
          </div>
          <h3>CNN for Object Classification</h3>
          <div className="portfolio__item-cta">
            <a href='https://github.com/jimmyschi/Computer-Vision/blob/master/ps7.py' className='btn' target='_blank'>Github</a>
            {/* <a href='https://github.com/jimmyschi' className='btn primary' target='_blank'>Live Demo</a> */}
          </div>
        </article>
        <article className="portfolio__item">
          <div className="portfolio__item-image">
            <img src={IMG2} alt="" />
          </div>
          <h3>Traveling Salesman Simulation</h3>
          <div className="portfolio__item-cta">
            <a href='https://github.com/jimmyschi/Simulations/blob/main/SchiavoJames_Final_Project.ipynb' className='btn' target='_blank'>Github</a>
            {/* <a href='https://github.com/jimmyschi' className='btn primary' target='_blank'>Live Demo</a> */}
          </div>
        </article>
        <article className="portfolio__item">
          <div className="portfolio__item-image">
            <img src={IMG5} alt="" />
          </div>
          <h3>System Engineering: Train System Simulation</h3>
          <div className="portfolio__item-cta">
            <a href='https://github.com/jimmyschi/Systems-Engineering/tree/main/README.md' className='btn' target='_blank'>Github</a>
            {/* <a href='https://github.com/jimmyschi' className='btn primary' target='_blank'>Live Demo</a> */}
          </div>
        </article>
        <article className="portfolio__item">
          <div className="portfolio__item-image">
            <img src={IMG6} alt="" />
          </div>
          <h3>Youtube Clone</h3>
          <div className="portfolio__item-cta">
            <a href='https://startling-monstera-c2d34a.netlify.app' className='btn' target='_blank'>Youtube Clone</a>
          </div>
        </article>
       
      </div>
    </section>
  )
}

export default Portfolio